import React from 'react';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { PropTypes } from 'prop-types';

import '../common.scss';
import './TimeRangePicker.scss';

export default function CsrmTimeRangePicker({
  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,
  showOutline,
  showLabels,
  useToSeperator,
}) {
  // TODO: manually typed dates are not triggering change detection or validation
  let skipAccept = false;
  let startTimeChanges = [];
  let endTimeChanges = [];
  return (
    <div className="csrm-time-range-picker">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          showToolbar
          ampmInClock
          disableCloseOnSelect
          label={showLabels ? 'Start Time' : ''}
          inputFormat="hh:mm a"
          mask="__:__ _M"
          value={startTime}
          error
          onChange={(value) => {
            startTimeChanges.push(value);
          }}
          onOpen={() => {
            startTimeChanges = [];
          }}
          onClose={() => {
            // Workaround to allow partially modified dates in picker to still save to state:
            // When user closes the picker before completing the predesignated workflow completely,
            // the picker will completely reset the selection in its final onChange. This workaround
            // takes the second to last change as the accepted value instead. Requires disableCloseOnSelect.
            startTimeChanges.splice(startTimeChanges.length - 1);
            onStartTimeChange(startTimeChanges[startTimeChanges.length - 1]);
            startTimeChanges = [];
            skipAccept = true;
          }}
          onAccept={(value) => {
            if (skipAccept) {
              skipAccept = false;
              return;
            }
            startTimeChanges = [];
            onStartTimeChange(value);
          }}
          renderInput={(params) => (
            <TextField
              className={`time-picker-input ${showOutline ? '' : 'no-outline'}`}
              {...params}
            />
          )}
        />
        {useToSeperator ? (
          <span style={{ textTransform: 'lowercase' }}>&nbsp;to&nbsp;</span>
        ) : (
          ''
        )}
        <TimePicker
          showToolbar
          ampmInClock
          disableCloseOnSelect
          label={showLabels ? 'End Time' : ''}
          inputFormat="hh:mm a"
          mask="__:__ _M"
          value={endTime}
          onChange={(value) => {
            endTimeChanges.push(value);
          }}
          onOpen={() => {
            endTimeChanges = [];
          }}
          onClose={() => {
            endTimeChanges.splice(endTimeChanges.length - 1);
            onEndTimeChange(endTimeChanges[endTimeChanges.length - 1]);
            endTimeChanges = [];
            skipAccept = true;
          }}
          onAccept={(value) => {
            if (skipAccept) {
              skipAccept = false;
              return;
            }
            endTimeChanges = [];
            onEndTimeChange(value);
          }}
          renderInput={(params) => (
            <TextField
              className={`time-picker-input ${showOutline ? '' : 'no-outline'}`}
              {...params}
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
}

CsrmTimeRangePicker.propTypes = {
  startTime: PropTypes.object.isRequired,
  onStartTimeChange: PropTypes.func.isRequired,
  endTime: PropTypes.object.isRequired,
  onEndTimeChange: PropTypes.func.isRequired,
  showOutline: PropTypes.bool,
  showLabels: PropTypes.bool,
  useToSeperator: PropTypes.bool,
};

CsrmTimeRangePicker.defaultProps = {
  showOutline: false,
  showLabels: false,
  useToSeperator: false,
};
